import { render, staticRenderFns } from "./campaign-create.vue?vue&type=template&id=3382a3bc"
import script from "./campaign-create.vue?vue&type=script&lang=js"
export * from "./campaign-create.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports